function ScrollProgress() {
	var _this = this;
	_this.progressBar = document.querySelector('.scroll-progress');

	_this.pro = function(){
		var progress = window.scrollY / (document.body.clientHeight - window.innerHeight);
		//this.progressBar.style.transform = `scaleX(${progress})
		TweenMax.to(_this.progressBar, 0.5, {
			scaleX: progress,
			ease: Expo.easeOut
		});
	};

	_this.init = function(){
		window.addEventListener('scroll', _this.pro, false);
	};
}
